module.exports = __webpack_public_path__ + "static/media/ic-download.eeff640c.svg";